// extracted by mini-css-extract-plugin
export default {"itemRoadmap":"y4SNzHF_Ev5tEyWIIbF8","selected":"ydZqVqMN4ztAAGegjtTb","dot":"CKp1d32BOTXFMFz9TSdu","blue":"huTla3PI2a8cHkCHsjEV","red":"RB4Gi1ebnkba1Fm_A2Eq"};